import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentAcceptOffer = (state: StateScheme) => {
    return state.payment.acceptOffer
}
